import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';

import { ErrorPopupProvider } from '../features/errors/ErrorPopupProvider';
import { queryClient } from '../lib/queryClient';
import { getRuntimeConfig } from '../lib/runtimeConfig';
import { installCrossTabSync } from './crossTabSync';
import { AppRouter } from './router';

export function AppRoot() {
  let runtimeError: unknown;
  if (import.meta.env.MODE !== 'test') {
    try {
      getRuntimeConfig(import.meta.env);
    } catch (error) {
      runtimeError = error;
    }
  }
  useEffect(() => installCrossTabSync(queryClient), []);
  if (runtimeError) {
    return (
      <ErrorPopupProvider initialError={runtimeError}>
        <main className="min-h-screen bg-bg-warm p-8 text-ink">
          ไม่สามารถเริ่มระบบ Dashboard ได้
        </main>
      </ErrorPopupProvider>
    );
  }
  return (
    <ErrorPopupProvider>
      <QueryClientProvider client={queryClient}>
        <AppRouter />
      </QueryClientProvider>
    </ErrorPopupProvider>
  );
}
